export const dictionary = {
  PAGE_TITLE: {
    ES: "Configuración de tu carrito",
    EN: "Cart settings",
  },
  PAGE_SUBTITLE: {
    ES: "Campos adicionales",
    EN: "Additional fields",
  },
  NEW_FIELD: {
    ES: "Nuevo campo",
    EN: "New field",
  },

  TITLE: {
    ES: "Título del campo",
    EN: "Title",
  },
  HELPERTEXT: {
    ES: "Agrega una nota al cliente",
    EN: "Add a note to the client",
  },
  ACTIVE: {
    ES: "Activo",
    EN: "Active",
  },
  REQUIRED: {
    ES: "Obligatorio",
    EN: "Required",
  },
  BOOLEAN: {
    ES: "Si/No",
    EN: "Boolean",
  },
  BOOLEAN_SUBTITLE: {
    ES: "Haz una pregunta a tus clientes en la cuál la respuesta sea SI o NO.",
    EN: "Make a question to your clients in which the answer is YES or NO.",
  },
  BOOLEAN_EXAMPLE: {
    ES: "Ejemplo: ¿Envolver para regalo?",
    EN: "Example: Wrap for gift?",
  },
  TEXT: {
    ES: "Texto largo",
    EN: "Long text",
  },

  TEXT_SUBTITLE: {
    ES: "Permite a tus clientes escribir una aclaración al realizar su pedido.",
    EN: "Allow your customers to make an observation when making the order.",
  },
  SHORT_TEXT: {
    ES: "Texto corto",
    EN: "Short Text",
  },
  SHORT_TEXT_SUBTITLE: {
    ES: "Permite a los clientes escribir una linea, como por ejemplo su nombre.",
    EN: "Allow your customers to write a line, for example their name.",
  },
  NUMBER: {
    ES: "Numero",
    EN: "Number",
  },
  NUMBER_SUBTITLE: {
    ES: "Permite a tus clientes escribir un número.",
    EN: "Allow your customers to write a number.",
  },
  PHONE_NUMBER: {
    ES: "Teléfono",
    EN: "Phone number",
  },
  PHONE_NUMBER_SUBTITLE: {
    ES: "Permite a tus clientes escribir su teléfono.",
    EN: "Allow your customers to write a phone number.",
  },
  DROPDOWN: {
    ES: "Opciones",
    EN: "Dropdown",
  },
  DROPDOWN_SUBTITLE: {
    ES: "Brinda opciones a tus clientes.",
    EN: "Provide options to your customers.",
  },
  MESSAGE: {
    ES: "Aclaración",
    EN: "Message",
  },
  MESSAGE_SUBTITLE: {
    ES: "Escribe un mensaje para tus clientes",
    EN: "Write a message to your customers",
  },
  DATE: {
    ES: "Fecha",
    EN: "Date",
  },
  DATE_SUBTITLE: {
    ES: "Permite a tus clientes elegir una fecha.",
    EN: "Allow your customers to choose a date.",
  },
  VARIANT_OPTIONS: {
    ES: "Opciones",
    EN: "Options",
  },
  ADD_OPTION: {
    ES: "Agregar nueva opción",
    EN: "Add a new option",
  },
  OPTION_TITLE: {
    ES: "Título de la opción",
    EN: "Option title",
  },
  AVAILABLE_DAYS: {
    ES: "Selecciona los días disponibles",
    EN: "Select the available days",
  },
  REMOVE_CONFIRM: {
    ES: "¿Estás seguro que deseas eliminar este campo? \n No podrás recuperarla.",
    EN: "Are you sure you want to delete this field? \n  You won't be able to recover it.",
  },
  CUSTOMER_NAME_SUBTITLE: {
    ES: "Permite a tus clientes escribir su nombre.",
    EN: "Allow your customers to write their name.",
  },
  CUSTOMER_PHONE_SUBTITLE: {
    ES: "Permite a tus clientes escribir su número de teléfono.",
    EN: "Allow your customers to write their phone number.",
  },
  MAX_FIELDS_REACHED: {
    ES: "Has alcanzado el máximo de campos permitidos.",
    EN: "You have reached the maximum number of fields allowed.",
  },
} as const;
